import { createStore, combineReducers, applyMiddleware } from "redux";
import promise from "redux-promise";
import session from "./../session/session";
import whitelabel from "./../whiteLabel/whiteLabel";
import layout from "../layout/layout";

/**
 * Configuração da store do Redux.
 * Combina os reducers e aplica o middleware para lidar com ações assíncronas.
 */

const reducers = combineReducers({
  whiteLabel: whitelabel,
  session: session,
  layout: layout,
});

function storeConfig() {
  return applyMiddleware(promise)(createStore)(reducers);
}

export default storeConfig;
